import { FronteggContext } from '@frontegg/rest-api';
import { Axios } from 'src/lib';
import {
  getOnboardingRolesSlice,
  getOnboardingSpecialtiesSlice,
} from '../slices/onboarding';

export const organizationRoles = () => {
  return async (dispatch) => {
    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${FronteggContext.getAccessToken()}`,
    };
    const result = await Axios.get(`/roles`, { headers });
    const response = result?.data?.roles;
    if (result?.status === 200 && response) {
      dispatch(getOnboardingRolesSlice(response));
    }
  };
};

export const organizationSpecialties = () => {
  return async (dispatch) => {
    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${FronteggContext.getAccessToken()}`,
    };
    const result = await Axios.get(`/specialties`, { headers });
    const response = result?.data?.specialties;
    if (result?.status === 200 && response) {
      dispatch(getOnboardingSpecialtiesSlice(response));
    }
  };
};
